import { render, staticRenderFns } from "./format-message.vue?vue&type=template&id=573a90ce&"
import script from "./format-message.vue?vue&type=script&lang=js&"
export * from "./format-message.vue?vue&type=script&lang=js&"
import style0 from "./format-message.vue?vue&type=style&index=0&id=573a90ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports